import React from 'react'
import { Grid, GridCell } from '@mobi/component-library/Legacy/Grid'
import { DogsFormRaceResponse } from '@core/Areas/Racing/Hooks/useRaceFormData/api'
import { FormDataStyled } from '../Common/Common.styles'
import { FormHistories } from '../Common/Histories'
import { DogsHistorySingle } from './DogsHistorySingle'

type DogsProps = {
  form?: DogsFormRaceResponse['Forms'][0]
  starterName?: string
}

export const Dogs: React.FC<DogsProps> = ({ form, starterName }) => {
  if (!form) return null

  return (
    <>
      <FormDataStyled>
        {form.RunnerComments && form.RunnerComments !== '-' && <div>{form.RunnerComments}</div>}
        <Grid>
          <GridCell width='50%'>
            <div data-testid='runner-form-career'>
              <strong>Career</strong> {form.Career}
            </div>
            <div data-testid='runner-form-prize'>
              <strong>Prize</strong> {form.PrizeMoneyWon}
            </div>

            <div data-testid='runner-form-dist'>
              <strong>Dist</strong> {form.Distance ?? '-'}
            </div>

            <div data-testid='runner-form-track'>
              <strong>Track</strong> {form.Track ?? '-'}
            </div>

            <div data-testid='runner-form-trk-dist'>
              <strong>Trk/Dist</strong> {form.TrackDistance}
            </div>

            <div data-testid='runner-form-first-up'>
              <strong>First Up</strong> {form.FirstUp ?? '-'}
            </div>

            <div data-testid='runner-form-age-sex'>
              <strong>Age/Sex</strong> {form.Age} / {form.Sex}
            </div>

            <div data-testid='runner-form-sire-dam'>
              <strong>Sire/Dam</strong> {form.SireName} / {form.DamName}
            </div>
          </GridCell>

          <GridCell width='50%'>
            <div data-testid='runner-form-last-starts'>
              <strong>Last Starts</strong> {form.LastTenStarts}
            </div>
            <div data-testid='runner-form-trainer'>
              <strong>Trainer</strong> {form.TrainerName ?? '-'}
            </div>
            <div data-testid='runner-form-owners' className='runner-form-owners'>
              <strong>Owners</strong>{' '}
              <span title={form.OwnerName ?? '-'}>{form.OwnerName ?? '-'}</span>
            </div>
            <div data-testid='runner-form-box'>
              <strong>Box</strong> {form.Box ?? '-'}
            </div>
            <div data-testid='runner-form-bt-dist'>
              <strong>BT @ Dist</strong> {form.BestTime ?? '-'}
            </div>
            <div data-testid='runner-form-lt-dist'>
              <strong>LT @ Dist</strong> {form.LastTime ?? '-'}
            </div>
            <div data-testid='runner-form-colour'>
              <strong>Colour</strong> {form.Color}
            </div>
          </GridCell>
        </Grid>
      </FormDataStyled>
      <FormDataStyled>
        {/* TODO: add expected settling position once available */}
        {/* <div data-testid='runner-form-expected-settling-position'>
          <strong>Expected Settling Position</strong> {form.ExpectedSettlingPosition ?? '-'}
        </div> */}
      </FormDataStyled>{' '}
      <FormHistories>
        {form.Histories.map(history => (
          <DogsHistorySingle
            key={history.FixtureDate}
            history={history}
            StarterName={starterName}
          />
        ))}
      </FormHistories>
    </>
  )
}
